import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { DocsSidebar } from './components/docs-sidebar';
import { DocsToc } from './components/docs-toc';
import { DocsTopNav } from './components/docs-top-nav';
import { DocHeading } from './types';

export type SetDocsHeadings = (headings: DocHeading[]) => void;

export default function DocsLayout() {
  const [headings, setHeadings] = useState<DocHeading[]>([]);

  return (
    <div className="flex h-svh w-full flex-col bg-background text-foreground">
      <DocsTopNav />
      <div className="flex min-h-0 flex-1">
        <DocsSidebar />
        <main className="min-w-0 flex-1 overflow-y-auto">
          <div className="mx-auto flex max-w-5xl gap-6 px-6 py-10">
            <div className="min-w-0 flex-1">
              <Outlet context={setHeadings satisfies SetDocsHeadings} />
            </div>
            <DocsToc headings={headings} />
          </div>
        </main>
      </div>
    </div>
  );
}
